"use client";

import { FavoriteTokenList } from "@/components/favorites/favorite-token-list";
import { Card, CardContent } from "@/components/ui/card";
import { useIdentity } from "@/contexts/IdentityContext";
import { useLanguage } from "@/hooks/useLanguage";
import { useUnifiedFavoriteTokens } from "@/hooks/useUnifiedFavoriteTokens";

export function SidebarFavorites() {
	const { isAuthenticated, principal } = useIdentity();
	const { getTranslation } = useLanguage();
	const { favorites, loading } = useUnifiedFavoriteTokens(principal, {
		isAuthenticated,
		enabled: true,
		limit: 10,
	});

	if (!loading && favorites.length === 0) return null;

	return (
		<Card className="rounded-2xl bg-light-surface dark:bg-dark-surface border-light-border dark:border-dark-border shadow-md">
			<CardContent className="p-6">
				<h4 className="font-medium text-light-text dark:text-dark-text mb-3">
					{getTranslation("plaza.myFavorites")}
				</h4>
				<FavoriteTokenList
					favorites={favorites}
					loading={loading}
					emptyText={getTranslation("plaza.noFavorites")}
				/>
			</CardContent>
		</Card>
	);
}
